import renderSections from 'components/sections';
import RichText from 'components/shared/richtext';
import styles from './faqQuestionContent.module.scss';

const FaqQuestionContent = ({ data, locale }) => {
  if (!data) return null;

  const { question, name, answer, sections } = data;

  return (
    <div className={styles.question}>
      {question && <h1 className={styles.title}>{question}</h1>}
      {answer?.json && (
        <div className={styles.answer}>
          <RichText
            text={answer.json}
            links={answer.links}
            locale={locale}
            imagesResponsive
            embeddedClasses={{}}
          />
        </div>
      )}
      {renderSections(name, locale, sections, undefined, { hubUrlSlug: data.hub?.urlSlug })}
    </div>
  );
};

export default FaqQuestionContent;
